import EmailPreferences from "../components/EmailPreferences";
import { useT } from "../i18n";

/** Página independiente de preferencias de email.
 *  Desde v2.7 los usuarios de org las gestionan en Alertas → "Preferencias de email";
 *  esta ruta la conserva el superadmin (enlace del TopBar), que no tiene página Alertas. */
export default function NotificationPreferencesPage() {
  const t = useT();
  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "2rem 1.5rem" }}>
      <h1 style={{ fontSize: "1.4rem", fontWeight: 700, letterSpacing: "-0.02em", color: "var(--clr-text)", margin: "0 0 4px" }}>
        {t("notifPrefs.title")}
      </h1>
      <EmailPreferences />
    </div>
  );
}
